import { getPlatform, getRunningEnv } from './getPlatform'
import Bridge from '../lib/Bridge'
import { getShortUrl } from '../component/wxToAPP/appCommand.js'
import { Base64 } from '../lib/base64'

/**
 * 微信下获取危险域名，非微信环境获取正常域名
 * @param {JSON} json 配置文件内容
 * @param {String} origin  获取哪个业务的域名，支持'MEDI'|'medi_origin'
 * @param {String} str 获取warn|safe|risk的类型，支持'm'|'m_warn' 默认使用_warn类型，
 * @param {String} wechat 默认只有微信下才用危险域名，设置为false即不管是不是微信都使用危险域名
 * @param {String} protocol 重新设定协议
 * @returns {String} 获取的域名,若匹配不到，return location.origin
 */

export const wxConfigOrigin = (
  json,
  origin,
  str,
  wechat = true,
  protocol = window.location.protocol
) => {
  let originUpper = origin.toUpperCase()
  if (!/_ORIGIN$/.test(originUpper)) {
    originUpper += '_ORIGIN'
  }

  let className = '_warn',
    typeName = str
  if (/_(warn|safe|risk)$/.test(str)) {
    let index = str.lastIndexOf('_')
    typeName = str.substring(index, 0)
    className = str.substr(index)
  }
  const platform = getPlatform()
  if (!platform.isWechat && wechat) {
    className = '_safe'
  }
  json = json['domain'][originUpper]
  if (json && json[typeName + className]) {
    return protocol + '//' + json[typeName + className]
  } else {
    throw new Error(
      "wxConfigOrigin:Can't match any origin with " + origin + str
    )
  }
}
/*
 * 比较版本号
 */
const versionfunegt = (appVer = '', standardVer = '') => {
  if (!appVer || !standardVer) return false
  let appVerArr = appVer.split('.').map(item => +item)
  let standardVerArr = standardVer.split('.').map(item => +item)

  if (appVerArr[0] !== standardVerArr[0]) {
    return appVerArr[0] > standardVerArr[0]
  } else {
    if (appVerArr[1] !== standardVerArr[1]) {
      return appVerArr[1] > standardVerArr[1]
    } else {
      return appVerArr[2] >= standardVerArr[2]
    }
  }
}

/* 获取链接钟的query */
const GetQueryString = (name, url) => {
  var reg = new RegExp(`(^|&?)${name}=([^&]*)(&|$)`)
  var r = (url || window.location.search.substr(1)).match(reg)
  if (r != null) return unescape(r[2])
  return null
}

// 可以唤端，但是重新下载后没办法直接打开web访问页面
// 需要下载app后打开指定页面请不要使用这个方法
const goApp = href => {
  let src = ''
  if (href.indexOf('yixinli://') > -1) {
    src = href.trim()
  } else {
    src = `yixinli://${href}`
  }
  let UA = window.navigator.userAgent.toUpperCase()

  // 判断微信环境
  if (/MICROMESSENGER/i.test(UA)) {
    if (window.toast) {
      window.toast('微信用户需要点击右上角菜单，使用“浏览器”打开~', 3000)
    } else {
      alert('微信用户需要点击右上角菜单，使用“浏览器”打开~')
    }
    return
  }
  const downloadLink =
    'https://a.app.qq.com/o/simple.jsp?pkgname=com.xinli.yixinli'
  const toDownload = () => {
    window.location.href = downloadLink
  }

  const platform = getPlatform()
  if (platform.isiPhone || platform.isiPad) {
    getShortUrl({
      remark: '引流唤端请求 - ' + document.title,
      long_url: downloadLink + '&app_link=' + encodeURIComponent(src)
    })
      .then(res => {
        if (res && res.www_short_url) {
          window.location.href = res.www_short_url
        } else {
          toDownload()
        }
      })
      .catch(() => {
        toDownload()
      })
  } else {
    window.location.href = src
    window.setTimeout(function() {
      toDownload()
    }, 2000)
  }
}

/**
 * 移动端跳转到下载，app内调协议更新
 */
const updateOrDownLoadApp = () => {
  const platform = getPlatform()
  const ua = window.navigator.userAgent
  const isApp = platform.isYixinliApp || platform.isCeShiApp
  const isAndroid = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1
  if (isApp) {
    let bridge = new Bridge()
    const _version = GetQueryString('_version', window.location.hash)
    // APP 5.2.1 才有执行更新方法（doUpgrade）
    if (versionfunegt(_version, '5.2.1')) {
      bridge.call('doUpgrade')
    } else {
      if (isAndroid) {
        // bridge.call('openWebView', {
        //   url: 'http://app-global.pgyer.com/3032d1cee33cd139f310f9f1da85caa9.apk?attname=yixinli-debug-20180816-175409.apk&sign=730cd838ae4b4c83f6af335e669bd51c&t=5b7671c5', // sdk原型上链接
        //   isCurrentPageOpen: 0
        // })
        const iframe = document.createElement('iframe')
        const src =
          'http://xinli001-file.oss-cn-hangzhou.aliyuncs.com/android_patch/yixinli.apk'
        iframe.src = src
        iframe.style = `width:0;height:0;overflow:hidden;position: absolute;`
        document.body.appendChild(iframe)
        setTimeout(() => document.body.removeChild(iframe), 2000)
      } else {
        // ios从浏览器打开应用宝
        // const a = document.createElement('a')
        const href =
          'http://a.app.qq.com/o/simple.jsp?open_by_broswer=1&pkgname=com.xinli.yixinli'
        bridge.call('openWebview', {
          url: href,
          isOpenByBrowser: 1
        })
        // a.href = href
        // document.body.appendChild(a)
        // a.click()
        // document.body.removeChild(a)
      }
    }
  } else {
    goApp()
  }
}

function throttle(fn, delay, mustRunDelay = 0) {
  let timer = null
  let tStart
  return function() {
    const context = this
    const args = arguments
    const tCurr = +new Date()
    clearTimeout(timer)
    if (!tStart) {
      tStart = tCurr
    }
    if (mustRunDelay !== 0 && tCurr - tStart >= mustRunDelay) {
      fn.apply(context, args)
      tStart = tCurr
    } else {
      timer = setTimeout(function() {
        fn.apply(context, args)
      }, delay)
    }
  }
}

function loadScript(url, callback) {
  return new Promise(resolve => {
    const script = document.createElement('script')
    // 遍历当前的script有没有已有的，已有的就不触发
    const scripts = Array.from(document.querySelectorAll('script'))
    const hasUrlScript = scripts.filter(i => {
      return i.getAttribute('src') === url
    })

    if (hasUrlScript.length > 0) {
      console.log(`script: ${url} has already been loaded, mission end`)
      return
    }
    script.type = 'text/javascript'
    if (typeof callback !== 'undefined') {
      if (script.readyState) {
        script.onreadystatechange = function() {
          if (
            script.readyState == 'loaded' ||
            script.readyState == 'complete'
          ) {
            script.onreadystatechange = null
            callback()
            resolve()
          }
        }
      } else {
        script.onload = resolve
      }
    }
    script.src = url
    document.body.appendChild(script)
  })
}

// 输入秒数，转换成 mm:ss的格式
function secondToTime(second) {
  let sec = `${Math.round(second) % 60}`.padStart(2, '0')
  let minute = `${(second / 60).toFixed(0)}`.padStart(2, '0')
  return `${minute}:${sec}`
}

/*
  秒数倒计时
  当start大于end的时候，认为是倒计时，否则是正计时，每次时间变化都调用callback
 */
function secondCounter(start, end, callback) {
  let countWay = start > end ? 'down' : 'up'
  if (start !== end) {
    setTimeout(() => {
      if (countWay === 'down') {
        secondCounter(start - 1, end, callback)
      } else {
        secondCounter(start + 1, end, callback)
      }
    }, 1000)
  }
  callback(start)
}

function getScrollTop() {
  // 试过了IOS和红米都有document.body.scrollTop，所以其他都不要了
  var scrollTop =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop
  return scrollTop
}

function setScrollTop(number) {
  if (number !== undefined && !Number.isNaN(number)) {
    console.log('setScrollTop', number)
    document.body.scrollTop = document.documentElement.scrollTop = window.pageYOffset = number
  }
}

function debounce(action, idle) {
  let last = null
  return function() {
    let ctx = this
    let args = arguments
    clearTimeout(last)
    last = setTimeout(function() {
      action.apply(ctx, args)
    }, idle)
  }
}

/**
 *
 * @param val Storage名
 * @param key 键名
 * @param day 过期时间  单位：天
 * @param writable  是否可以set
 * @returns {boolean} false:未过期   true:已过期
 * @constructor
 */
const handleExpiresStorage = (val, key, day, writable = false) => {
  let StorageObj = JSON.parse(localStorage.getItem(val))
  let StorageMap = new Map()
  const curTime = Date.now()
  for (let key in StorageObj) {
    StorageMap.set(key, StorageObj[key])
  }
  let keyValue = StorageMap.get(key)
  if (keyValue) {
    let interval = curTime - keyValue
    if (interval < 0) return false //未过期
  }
  if (writable) {
    localStorage.removeItem(val)
    StorageMap.set(key, curTime + day * 1000 * 86400)
    let objFromMap = {}
    for (let [k, v] of StorageMap) {
      objFromMap[k] = v
    }
    localStorage.setItem(val, JSON.stringify(objFromMap))
  }
  return true
}

// 判断是不是隐藏了头部，全屏显示
const isCanHideNavigationBar = platform => {
  const {
    isYixinliApp,
    yixinliAPPVersion,
    isZiXunApp,
    zixunAppVersion,
    isZiXunShiApp
  } = platform

  const isYixinliAppVersionWork =
    isYixinliApp && versionfunegt(yixinliAPPVersion, '5.9.0')
  const isZiXunAppVersionWork =
    isZiXunApp && versionfunegt(zixunAppVersion, '4.0.0')

  return (
    (isYixinliAppVersionWork || isZiXunAppVersionWork || isZiXunShiApp) &&
    window.screen.height - document.documentElement.clientHeight < 50 // 高度差小于50就认为是全面屏，考虑ipx底部，安卓操作条
  )
}

const getStatusBarHeight = () =>
  new Promise((resolve, reject) => {
    try {
      const bridge = new Bridge({
        methods: [
          {
            method: 'areaListHasNotch',
            callback: obj => {
              const { hasNotch, notchHeight } = obj
              const statusBarHeight =
                notchHeight && window.devicePixelRatio
                  ? (notchHeight / window.devicePixelRatio) | 0
                  : hasNotch === 1 || hasNotch === true
                  ? this.$platform.isAndroid
                    ? 35
                    : 40
                  : 20
              resolve(statusBarHeight)
            }
          }
        ]
      })

      bridge.call('hasNotch', {
        callbackName: 'areaListHasNotch'
      })
    } catch (e) {
      reject(e)
    }
  })

const isDangerUrl = (host = window.location.hostname) => {
  const dangerUrls = [
    'xinli001.com',
    'xinli001.xin',
    'xinli001.cc',
    'xinli001.net',
    'pgxinli.com',
    'zixunshizhijia.com'
  ]

  const isProd = getRunningEnv().env === ''
  const isWechat = getPlatform().isWechat

  if (!isProd || !isWechat) return false
  let isDanger = false

  for (let i = 0; i < dangerUrls.length; i++) {
    const url = dangerUrls[i]
    if (host.indexOf(url) > -1) {
      isDanger = true
    }
  }

  return isDanger
}

const chunkArray = (data, length) => {
  const newArr = []

  for (var i = 0; i < data.length; i += length) {
    newArr.push(data.slice(i, i + length))
  }

  return newArr
}

const getRunTime = str => {
  let result
  let _href = window.location.href.split('.')[0]
  _href.replace(/-([A-Za-z0-9]*)/, (s, v) => {
    result = str.replace(/\./, `-${v}.`)
  })

  if (!result) {
    result = str
  }

  return result
}

const updateQueryStringParameter = (url, key, value) => {
  if (!value) {
    return url
  }
  const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  const separator = url.indexOf('?') !== -1 ? '&' : '?'
  if (url.match(re)) {
    return url.replace(re, '$1' + key + '=' + value + '$2')
  } else {
    return url + separator + key + '=' + value
  }
}

/**
 * 批量添加链接参数
 */
const addQueryToUrl = (url, querys) => {
  if (!url || !querys) return url

  for (let key in querys) {
    url = updateQueryStringParameter(url, key, querys[key])
  }

  return url
}

/**
 *
 * @param dateObj 日期对象 Date Object
 * @param fmt 格式，字符串类型，YY代表年，MM代表月，DD代表日，hh时，mm分，ss秒，SS毫秒
 * @returns {*}
 */
const dateFormater = (dateObj, fmt) => {
  if (dateObj instanceof Date) {
    console.log('dateObj is good')
  } else if (typeof dateObj == 'string') {
    dateObj = new Date(dateObj.replace(/-/g, '/'))
  } else {
    console.error('日期数据格式错误')
    return
  }
  var o = {
    'M+': dateObj.getMonth() + 1, //月份
    'D+': dateObj.getDate(), //日
    'h+': dateObj.getHours(), //小时
    'm+': dateObj.getMinutes(), //分
    's+': dateObj.getSeconds(), //秒
    'q+': Math.floor((dateObj.getMonth() + 3) / 3), //季度
    S: dateObj.getMilliseconds() //毫秒
  }
  if (/(Y+)/.test(fmt))
    fmt = fmt.replace(
      RegExp.$1,
      (dateObj.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  for (var k in o)
    if (new RegExp('(' + k + ')').test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
  return fmt
}

// 判断是否base64字符串
const isBase64 = str => {
  if (str === '' || (typeof str === 'string' && str.trim() === '')) {
    return false
  }
  try {
    return Base64.encodeURI(Base64.decode(str)) == str
  } catch (err) {
    return false
  }
}

// 解码url参数
const decodeUrlQuery = str => {
  return isBase64(str) ? Base64.decode(str) : decodeURIComponent(str)
}

export default {
  updateOrDownLoadApp,
  goApp,
  GetQueryString,
  throttle,
  loadScript,
  getScrollTop,
  setScrollTop,
  debounce,
  versionfunegt,
  handleExpiresStorage,
  secondCounter,
  secondToTime,
  isCanHideNavigationBar,
  getStatusBarHeight,
  isDangerUrl,
  chunkArray,
  getRunTime,
  updateQueryStringParameter,
  addQueryToUrl,
  dateFormater,
  isBase64,
  decodeUrlQuery
}

export {
  updateOrDownLoadApp,
  goApp,
  GetQueryString,
  throttle,
  loadScript,
  getScrollTop,
  setScrollTop,
  debounce,
  versionfunegt,
  handleExpiresStorage,
  secondCounter,
  secondToTime,
  isCanHideNavigationBar,
  getStatusBarHeight,
  isDangerUrl,
  chunkArray,
  getRunTime,
  updateQueryStringParameter,
  addQueryToUrl,
  dateFormater,
  isBase64,
  decodeUrlQuery
}



// WEBPACK FOOTER //
// ./src/frontend-lib/tools/utils.js